import _regenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { getMyBizList } from '@/api/cmdb';
import router from '@/router';
var state = {
  currBiz: null,
  bizList: [],
  currBizName: '',
  currBizCode: ''
};
var mutations = {
  SET_CURR_BIZ: function SET_CURR_BIZ(state, currBiz) {
    state.currBiz = currBiz;
    sessionStorage.setItem('currBiz', state.currBiz);
  },
  SET_BIZ_LIST: function SET_BIZ_LIST(state, bizList) {
    state.bizList = bizList;
  },
  SET_CURR_BIZ_NAME: function SET_CURR_BIZ_NAME(state, currBizName) {
    state.currBizName = currBizName;
    sessionStorage.setItem('currBizName', currBizName);
  },
  SET_CURR_BIZ_CODE: function SET_CURR_BIZ_CODE(state, currBizCode) {
    state.currBizCode = currBizCode;
    sessionStorage.setItem('currBizCode', state.currBizCode);
  }
};
var actions = {
  refreshBiz: function () {
    var _refreshBiz = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
      var commit, list, urlBizCode, route, urlBiz, currBiz, currBizCode, currBizName, cachedBiz;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            commit = _ref.commit;
            _context.n = 1;
            return getMyBizList({
              system: 'job'
            });
          case 1:
            list = _context.v;
            console.log(list);
            commit('SET_BIZ_LIST', list);
            if (!(list.length > 0)) {
              _context.n = 3;
              break;
            }
            // 1. 首先尝试从 URL 中获取业务代码
            urlBizCode = null;
            route = router.currentRoute;
            if (!(route.params && route.params.biz_code && route.params.biz_code !== ':biz_code')) {
              _context.n = 2;
              break;
            }
            urlBizCode = route.params.biz_code;

            // 如果 URL 中有业务代码，则查找对应的业务信息
            urlBiz = list.find(function (biz) {
              return biz.code === urlBizCode;
            });
            if (!urlBiz) {
              _context.n = 2;
              break;
            }
            // 使用 URL 中的业务信息
            commit('SET_CURR_BIZ', urlBiz.id);
            commit('SET_CURR_BIZ_NAME', urlBiz.name);
            commit('SET_CURR_BIZ_CODE', urlBiz.code);

            // 已经从 URL 中获取到业务信息，直接返回
            return _context.a(2);
          case 2:
            // 2. 如果 URL 中没有业务代码，则尝试从 sessionStorage 中获取
            currBiz = parseInt(sessionStorage.getItem('currBiz'));
            currBizCode = sessionStorage.getItem('currBizCode');
            currBizName = sessionStorage.getItem('currBizName'); // 如果 sessionStorage 中有完整的业务信息，则使用
            if (currBiz && currBizCode && currBizName) {
              commit('SET_CURR_BIZ', currBiz);
              commit('SET_CURR_BIZ_NAME', currBizName);
              commit('SET_CURR_BIZ_CODE', currBizCode);
            } else {
              // 3. 否则尝试从业务列表中查找
              cachedBiz = list.find(function (o) {
                return o.id === currBiz;
              });
              if (cachedBiz) {
                commit('SET_CURR_BIZ', cachedBiz.id);
                commit('SET_CURR_BIZ_NAME', cachedBiz.name);
                commit('SET_CURR_BIZ_CODE', cachedBiz.code);
              } else {
                // 4. 如果都没有，则使用第一个业务
                commit('SET_CURR_BIZ', list[0].id);
                commit('SET_CURR_BIZ_NAME', list[0].name);
                commit('SET_CURR_BIZ_CODE', list[0].code);
              }
            }
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    function refreshBiz(_x) {
      return _refreshBiz.apply(this, arguments);
    }
    return refreshBiz;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};